<script setup lang="ts"></script>

<template>&nbsp;</template>

<style lang="scss" scoped>
.DocumentLineEnter {
}
</style>
